// extracted by mini-css-extract-plugin
export default {"root":"ResetPassword_root__E8chA","card":"ResetPassword_card__SKBXZ","content":"ResetPassword_content__fmfHH","logo":"ResetPassword_logo__MEdlg"};